import flatpickr from 'flatpickr'
import { english } from 'flatpickr/dist/l10n/default.js'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import { French } from 'flatpickr/dist/l10n/fr.js'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import { Italian } from 'flatpickr/dist/l10n/it.js'
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
import { Dutch } from 'flatpickr/dist/l10n/nl.js'
import { German } from 'flatpickr/dist/l10n/de.js'
import { Malaysian } from 'flatpickr/dist/l10n/ms.js'
import { Thai } from 'flatpickr/dist/l10n/th.js'
import { Mandarin } from 'flatpickr/dist/l10n/zh.js'
import { Arabic } from 'flatpickr/dist/l10n/ar.js'

const FLATPICKR_LOCALES = {
  en: english,
  ja: Japanese,
  fr: French,
  es: Spanish,
  it: Italian,
  pt: Portuguese,
  nl: Dutch,
  de: German,
  ms: Malaysian,
  th: Thai,
  zh: Mandarin,
  ar: Arabic,
}

/**
 * Normalises a locale string by trimming whitespace and replacing underscores with hyphens.
 *
 * @param {string} locale - The locale string to normalise.
 * @returns {string} - The normalised locale string.
 */
const normaliseLocale = (locale) => {
  if (typeof locale !== 'string') {
    return ''
  }

  return locale.trim().replace(/_/g, '-').toLowerCase()
}

/**
 * Resolves the Flatpickr locale from the store locale code.
 * @param {string} locale - The store locale string (for example: en-GB, ja-JP).
 * @returns {string} - The resolved Flatpickr locale code.
 */
const resolveSupportedLocaleCode = (locale) => {
  const normalizedLocaleCode = normaliseLocale(locale).split('-')[0]

  return normalizedLocaleCode
}

const resolveStoreLocale = (store) => store?.getters?.locale

const applyFlatpickrLocale = (locale) => {
  const supportedLocale = resolveSupportedLocaleCode(locale)

  const flatpickrLocale = FLATPICKR_LOCALES[supportedLocale]

  if (!flatpickrLocale) {
    console.warn(`Unsupported locale '${locale}' resolved to '${supportedLocale}'. Flatpickr will default to English.`)
    return
  }

  flatpickr.localize(flatpickrLocale)
}

export default ({ store }) => {
  applyFlatpickrLocale(resolveStoreLocale(store))

  /*
   * Vuex → Flatpickr
   */

  store.watch(
    (state) => state.locale,
    (locale) => {
      applyFlatpickrLocale(locale)
    }
  )

  if (typeof window !== 'undefined') {
    window.flatpickr = flatpickr
  }
}
